import { ChangeDetectionStrategy, Component } from "@angular/core";
import { trigger, transition, style, animate } from "@angular/animations";
import { NgClass } from "@angular/common";
import { MatIconModule } from "@angular/material/icon";
import { FlexLayoutModule, FlexModule } from "@ngbracket/ngx-layout";
import { MatButtonModule } from "@angular/material/button";
import { MatTooltipModule } from "@angular/material/tooltip";
import { TranslateModule } from "@ngx-translate/core";
import { ToastMessage, ToastService } from "~/core/services/toast.service";
import { UtilsService } from "~/core/helpers/utils";
import { dsButtonClass, dsButtonVariant } from "~/dash/core/ds-button.shared";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "app-toast",
  templateUrl: "./toast.component.html",
  styleUrls: ["./toast.component.scss"],
  animations: [
    trigger("slideInOut", [
      transition(":enter", [
        style({ transform: "translateX(100%)", opacity: 0 }),
        animate("300ms ease-out", style({ transform: "translateX(0)", opacity: 1 })),
      ]),
      transition(":leave", [animate("300ms ease-in", style({ transform: "translateX(100%)", opacity: 0 }))]),
    ]),
  ],
  imports: [NgClass, MatIconModule, FlexModule, MatButtonModule, MatTooltipModule, TranslateModule, FlexLayoutModule],
})
export class ToastComponent {
  // template helpers for the dynamic `color` the old st-button took
  readonly dsVariant = dsButtonVariant;
  readonly dsClass = dsButtonClass;
  readonly toasts = this.toastService.toasts;
  // Read once: the toast host is never re-created on resize, and the async pipe
  // is what marks this component dirty.
  readonly isDesktop = UtilsService.isDesktop();

  constructor(private toastService: ToastService) {}

  dismissToast(toast: ToastMessage) {
    this.toastService.dismissToast(toast);
  }

  clickToast(toast: ToastMessage) {
    if (toast.click) {
      toast.click();
    }

    this.dismissToast(toast);
  }
}
